<template>
  <div>
    <FormComponent @created="refreshList" @clear-prefill="clearPrefill" :prefillData="prefillData" />
    <ListComponent :reload="reloadList" @copy-campaign="onCopyCampaign" />
  </div>
</template>

<script>
import FormComponent from "@/components/YatriCampaign/yatri-campaign-form.vue";
import ListComponent from "@/components/YatriCampaign/yatri-campaign-list.vue";

export default {
  components: { FormComponent, ListComponent },

  data() {
    return {
      reloadList: false,
      prefillData: null,
    };
  },

  methods: {
    refreshList() {
      this.reloadList = !this.reloadList;
    },
    clearPrefill() {
      this.prefillData = null;
    },
    onCopyCampaign(item) {
      this.prefillData = { ...item };
    }
  }
};
</script>
